import RecruitingInterviewResults from './results/RecruitingInterviewResults';
import MultipleChoiceExamResults from './results/MultipleChoiceExamResults';
import ExamDetailSkeleton from '../../components/ExamDetailSkeleton';
import CodingExamResults from './results/CodingExamResults';
import ExamTabs from '../../components/ExamTabs';
import { useExamDetail } from '../../hooks/useExamDetail';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './style.module.scss';

export default function ExamResults() {
    const navigate = useNavigate();
    const { examinerId } = useParams();
    const {
        tab,
        tabs,
        fetching,
        changeTab,
        codingExam,
        multipleChoiceExam,
        recruitingInterview,
    } = useExamDetail();

    const renderResults = () => {
        if (fetching) return <ExamDetailSkeleton sections={6} />;

        switch (tab) {
            case 'recruitingInterview':
                return <RecruitingInterviewResults
                    applicantId={examinerId}
                    interviewData={recruitingInterview}
                />;
            case 'multipleChoice':
                return <MultipleChoiceExamResults
                    examData={multipleChoiceExam}
                    examinerData={multipleChoiceExam?.examiners.find(examiner => examiner.userId === examinerId)}
                />;
            case 'coding':
                return <CodingExamResults
                    examData={codingExam}
                    examinerData={codingExam?.examiners.find(examiner => examiner.userId === examinerId)}
                />;
            default:
                return null;
        }
    };

    return (
        <div className={styles.container}>
            <span className={styles.backToList} onClick={() => navigate(-1)}>
                Back to exam statistics
            </span>

            <div className={styles.main}>
                <div className={styles.main_header}>
                    <span className={styles.main_header_title}>Exam sheet</span>
                </div>

                <ExamTabs tabs={tabs} activeTab={tab} onChange={changeTab} />

                <div className={styles.main_table}>
                    {renderResults()}
                </div>
            </div>
        </div>
    );
};
